import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Postulacion } from 'src/app/interfaces/postulacion';
import { Response } from 'src/app/interfaces/response';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PostulacionService {

  private baseApiUrl = environment.baseApi + '/privado/postulacion';

  constructor(private httpClient: HttpClient) { }

  async obtenerPosutlacionesPorIdCandidato(idCandidato: number, buscador: string): Promise<Response> {
    return await this.httpClient.get<Response>(`${this.baseApiUrl}/candidato/${idCandidato}/buscar/${buscador}`).toPromise();
  }

  async obtenerPosutlacionPorCandidatoYVacante(idCandidato: number, idVacante: number): Promise<Response> {
    return await this.httpClient.get<Response>(`${this.baseApiUrl}/candidato/${idCandidato}/${idVacante}`).toPromise();
  }

  async obtenerPosutlacionesPorIdEmpresa(idEmpresa: number, buscar: string): Promise<Response> {
    return await this.httpClient.get<Response>(`${this.baseApiUrl}/empresa/${idEmpresa}/buscar/${buscar}`).toPromise();
  }

  registrarPostulacion(body: Postulacion): Observable<Response> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.httpClient.post<Response>(`${this.baseApiUrl}`, body, { headers });
  }

  actualizarEstatusPostulacion(idPostulacion: number, estatus: string): Observable<Response> {
    return this.httpClient.put<Response>(`${this.baseApiUrl}/${idPostulacion}/estatus/${estatus}`, null);
  }
}
